import { ThemeProvider } from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { defaultTheme } from './theme/theme';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './containers/Header';
import Footer from './containers/Footer';
import Board from './containers/Board';
import HomePage from './containers/Board/HomePage';
import BalanceOpeningPage from './containers/Board/BalanceOpeningPage';
import Messages from './containers/Board/Messages';
import AuditLog from './containers/Board/AuditLog';
import LoginPage from './containers/Board/LoginPage';
import MainActions, { MainSelectors } from './redux/MainRedux';
import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { createBrowserHistory } from 'history';

export const history = createBrowserHistory({
    basename: process.env.PUBLIC_URL
});

function App(props) {
    const { isLoggedin } = props;
	
	useEffect(() => {
		if (isLoggedin) {
			if (!Cookies.get('camra-token')) {
				props.setLogout();
			}
		}
	});

	return (
		<ThemeProvider theme={defaultTheme}>
			<Router>
				<Header {...props}/>
				<Routes>
					{!isLoggedin && (<Route path='*' element={<Navigate to='login' />} />)}
					
					<Route path='login' element={isLoggedin ? <Board {...props}/> : <LoginPage {...props}/>}/>

                    <Route path="homepage" element={isLoggedin ? <HomePage {...props}/> : <Navigate to='login' />}/>

                    <Route path="openingbalances/*" element={isLoggedin ? <BalanceOpeningPage {...props}/> : <Navigate to='login' />}/>
                    <Route path="openingbalances/:subTabPath" element={isLoggedin ? <BalanceOpeningPage {...props}/> : <Navigate to='login' />}/>
					
                    <Route path="admin/messages/*" element={isLoggedin ? <Messages {...props}/> : <Navigate to='login' />}/>
                    <Route path="admin/messages/:subTabPath" element={isLoggedin ? <Messages {...props}/> : <Navigate to='login' />}/>
					
                    <Route path="admin/auditlog/*" element={isLoggedin ? <AuditLog {...props}/> : <Navigate to='login' />}/>

					<Route path='*' element={<Board {...props}/>}/>
				</Routes>
				<Footer />
			</Router>
		</ThemeProvider>
	);
}

App.propTypes = {
    history: PropTypes.object,
	isLoggedin: PropTypes.bool,
	databaseName: PropTypes.string,
	pageTitle: PropTypes.string,
	user: PropTypes.object,
	settings: PropTypes.object,
    setLogin: PropTypes.func,
	setLogout: PropTypes.func,
    setDatabaseName: PropTypes.func,
	setPageTitle: PropTypes.func,
	setSettings: PropTypes.func,
	setBaseYear: PropTypes.func,
};

const mapStatesToProps = state => ({
	isLoggedin: MainSelectors.selectLoggedIn(state),
	databaseName: MainSelectors.selectDatabaseName(state),
	pageTitle: MainSelectors.selectPageTitle(state),
	smallPageTitle: MainSelectors.selectSmallPageTitle(state),
	user: MainSelectors.selectUser(state),
	settings: MainSelectors.selectSettings(state),
	baseYear: MainSelectors.selectBaseYear(state),
});

const mapDispatchToProps = dispatch => ({
    setLogin: (user) => dispatch(MainActions.setLogin(user)),
	setLogout: () => dispatch(MainActions.setLogout()),
    setDatabaseName: (dbname) => dispatch(MainActions.setDatabaseName(dbname)),
    setPageTitle: (pageTitle) => dispatch(MainActions.setPageTitle(pageTitle)),
    setSmallPageTitle: (smallPageTitle) => dispatch(MainActions.setSmallPageTitle(smallPageTitle)),
	setSettings: (settings) => dispatch(MainActions.setSettings(settings)),
	setBaseYear: (baseYear) => dispatch(MainActions.setBaseYear(baseYear)),
});

export default connect(
	mapStatesToProps,
	mapDispatchToProps
)(App);